import { fetcherWithToken } from '@/shared/api/fetcher';
import type { GamesByIdsKey } from './games-by-ids-logic';

export const fetchGamesByIds = async ([
  ,
  ,
  stableIdsKey,
]: GamesByIdsKey): Promise<unknown> => {
  const query = new URLSearchParams({ ids: stableIdsKey });
  return fetcherWithToken(`/games/by-ids?${query.toString()}`);
};
